import { PropertyMappingTypeEnum } from './property-mapping-type.enum';

export const ViewColumnMappingTypeEnum = {
  ...PropertyMappingTypeEnum,
  computed: 'computed',
} as const;
export type ViewColumnMappingTypeEnum =
  (typeof ViewColumnMappingTypeEnum)[keyof typeof ViewColumnMappingTypeEnum];
